import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getCurrentEpaySettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/epay/settings/:bankGlAccountId`
    },

    saveConvenienceFee: {
        method: 'PUT',
        url: `${BASE_PATH_API}/banking/epay/settings/:bankGLAccountId/eft`
    },

    bulkUpdateConvenienceFee: {
        method: 'PUT',
        url: `${BASE_PATH_API}/banking/epay/settings/bulk/eft`
    },

    saveAdditionalCreditCardFee: {
        method: 'PUT',
        url: `${BASE_PATH_API}/banking/epay/settings/:bankGlAccountId/creditCard`
    },

    bulkUpdateAdditionalCreditCardFee: {
        method: 'PUT',
        url: `${BASE_PATH_API}/banking/epay/settings/bulk/creditCard`
    },

    getAllOwnerContributionSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/epay/settings/:bankGlAccountId/allRentalOwners`
    },

    saveAllOwnerContributionSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/banking/epay/settings/:bankGlAccountId/allRentalOwners`
    },

    getEFTSettingsForActiveBankAccountsWithEFTEnabled: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/epay/settings/bulk/eft`
    },

    getCCSettingsForActiveBankAccountsWithCCEnabled: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/epay/settings/bulk/creditCard`
    },

    getApplications: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/epay/applications`
    },

    getTicketSupportEmailAddress: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/epay/ticketSupportEmail`
    }
};

export function EpaySettingsApi() {
    return createActions(actions);
}
